/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import propTypes from 'prop-types';
import styled from 'styled-components';

const BackdropWrapper = styled.div`
  width: 100%;
  height: 100vh;
  position: fixed;
  z-index: ${({ isPermissionPane }) => (isPermissionPane ? 2 : 5)};
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.5);

  @media screen and (min-width: 1024px) {
    display: ${(props) => (props.toShow ? 'block' : 'none')};
  }
`;

const backdrop = ({ show, clicked, toShow, isPermissionPane }) =>
  show ? (
    <BackdropWrapper
      isPermissionPane={isPermissionPane}
      onClick={clicked}
      toShow={toShow}
      data-testid="backdrop"
    />
  ) : (
    <></>
  );

backdrop.propTypes = {
  show: propTypes.bool.isRequired,
  clicked: propTypes.func.isRequired,
};

export default backdrop;
